import React, { useState, useEffect } from "react";
import { config } from "./config"; // 加载配置
import "./Test.css";
import { fetchData, fetchData_from_patient } from "./DataFetcher";
import "./Form.css";
import { useNavigate } from "react-router-dom";
// import { Flex, Button, View, Text } from "@aws-amplify/ui-react";
import { Flex, View, SelectField, Button } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import PatientDataPage from "./PatientDataPage";
const debug = config.debug();
const today = config.getUTC8Time();

const parseTimeString = (timeString) => {
  const [year, month, day, hour, minute, second] = timeString
    .split("-")
    .map(Number);
  return new Date(year, month - 1, day, hour, minute, second);
};

function compareDate(time1, time2) {
  // 修改参数名称
  console.log("time1", time1);
  console.log("time2", time2);
  const date1 = parseTimeString(time1); // 使用正确的参数名称
  const date2 = parseTimeString(time2); // 使用正确的参数名称
  // 计算时间差（以毫秒为单位）
  const timeDifference = date2 - date1;

  // 将时间差转换为分钟
  const differenceInMinutes = timeDifference / (1000 * 60);
  console.log("differenceInMinutes", differenceInMinutes);
  return differenceInMinutes < config.localStorageTimeout; // 如果时间差小于30分钟，返回true
}

function calculateAge(birthday) {
  try {
    // 解析生日和今天的日期
    const birthDate = new Date(
      parseInt(birthday.substring(0, 4)),
      parseInt(birthday.substring(4, 6)) - 1,
      parseInt(birthday.substring(6, 8))
    );

    // 計算年齡的年數和月數
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    // 如果月份差為負數，則減去一年並加上12個月
    if (months < 0) {
      years--;
      months += 12;
    }
    if (days < 0) {
      months--;
    }

    // 返回格式化的年齡字符串
    return `${years}y${months}m`;
  } catch (error) {
    // 如果發生任何錯誤，返回 "--"
    return "--";
  }
}
const updateCurrentData = async (selectedData) => {
  // 新增非同步函式
  let currentData = selectedData[1];
  for (let i = 0; i < currentData.length; i++) {
    if (!currentData[i].first) {
      console.log("currentData[i]", currentData[i]);
      let dataFromPatient = await fetchData_from_patient(currentData[i].ID);
      if (dataFromPatient.length > 0) {
        if (dataFromPatient[0].hasOwnProperty("data")) {
          // 取得今天日期
          // const today = new Date();

          // 遍歷dataFromPatient[0].data的日期
          Object.keys(dataFromPatient[0].data).forEach((date) => {
            const visitDate = new Date(date);
            const diffDays = Math.floor(
              (today - visitDate) / (1000 * 60 * 60 * 24)
            );

            // 檢查是否在過去21-97天之間
            if (diffDays >= 21 && diffDays <= 97) {
              const visitData = dataFromPatient[0].data[date];

              // 檢查daflon和growthHormone
              if (visitData.daflon === true) {
                currentData[i].daflon = true;
              }
              if (visitData.daflon4W === true) {
                currentData[i].daflon = true;
              }
              if (visitData.growthHormone === true) {
                currentData[i].growthHormone = true;
              }
              if (visitData.omnitrop === true) {
                currentData[i].omnitrop = true;
              }
            }
          });

          currentData[i].patientData = dataFromPatient[0];
        }
      }
    }
  }
  selectedData[1] = currentData;
  return selectedData;
};

const RenderTable = ({ selectedData, setPatientData, user }) => {
  let currentDate = selectedData[0];
  let currentData = selectedData[1];
  // console.log("selectedData", selectedData);
  // console.log("currentDate", currentDate);
  // console.log("currentData", currentData);
  // const updateCurrentData = async () => { // 新增非同步函式
  //   for (let i = 0; i < currentData.length; i++) {
  //     if (!currentData[i].first) {
  //       console.log("currentData[i]", currentData[i]);
  //       let dataFromPatient = await fetchData_from_patient(currentData[i].ID);
  //       if (dataFromPatient.length > 0) {
  //         if (dataFromPatient[0].hasOwnProperty("data")) {
  //           // 取得今天日期
  //           // const today = new Date();

  //           // 遍歷dataFromPatient[0].data的日期
  //           Object.keys(dataFromPatient[0].data).forEach(date => {
  //             const visitDate = new Date(date);
  //             const diffDays = Math.floor((today - visitDate) / (1000 * 60 * 60 * 24));

  //             // 檢查是否在過去51-98天之間
  //             if (diffDays >= 51 && diffDays <= 98) {
  //               const visitData = dataFromPatient[0].data[date];

  //               // 檢查daflon和growthHormone
  //               if (visitData.daflon === true) {
  //                 currentData[i].daflon = true;
  //               }
  //               if (visitData.growthHormone === true) {
  //                 currentData[i].growthHormone = true;
  //               }
  //             }
  //           });

  //           currentData[i].patientData = dataFromPatient[0];
  //         }
  //       }
  //     }
  //   }
  // };
  // updateCurrentData();

  /**
   * 顯示病人資料並準備跳轉到病人資料頁面
   * @param {Object} oneData - 包含病人基本資料的物件，包括ID、姓名、生日等資訊
   * @returns {Promise<void>} 無返回值
   * @description 此函數會執行以下操作:
   * 1. 從資料庫獲取病人完整資料
   * 2. 如果是新病人(無資料)，設定為初診且醫生為李如浩
   * 3. 確保資料結構完整(data物件存在)
   * 4. 將當前預約時間資訊(hour, time)存入對應日期的資料中
   * 5. 設定病人資料狀態，觸發頁面跳轉
   */
  const showPatientData = async (oneData) => {
    let dataFromPatient = await fetchData_from_patient(oneData.ID);
    console.log("dataFromPatient", dataFromPatient);
    let oneDataNew = JSON.parse(JSON.stringify(oneData));
    // 檢查是否有暫存資料的cookie
    let tempSave =
      document.cookie
        .split(";")
        .find((row) => row.trim().startsWith("tempSave=")) &&
      JSON.parse(
        document.cookie
          .split(";")
          .find((row) => row.trim().startsWith("tempSave="))
          .split("=")[1]
      ).date === (await config.gettodayymd());
    if (dataFromPatient.length > 0) {
      oneDataNew = JSON.parse(JSON.stringify(dataFromPatient[0]));
      if (!oneDataNew.hasOwnProperty("first")) {
        oneDataNew.first = false;
      }
    } else {
      oneData.doctor = "李如浩";
    }

    if (!oneDataNew.data) {
      oneDataNew.data = {};
    }

    // 检查oneData.data.currentDate是否存在
    if (!oneDataNew.data[currentDate]) {
      oneDataNew.data[currentDate] = {};
    }
    oneDataNew.currentDate = currentDate;
    console.log("oneDataNew", oneDataNew);
    let hour = oneData.hour;
    let time = oneData.time;
    if (oneDataNew.hour) {
      delete oneDataNew.hour;
    }
    if (oneDataNew.time) {
      delete oneDataNew.time;
    }
    oneDataNew.data[currentDate].hour = hour;
    oneDataNew.data[currentDate].time = time;
    setPatientData(oneDataNew); // 設置patientData， 然後會跳轉到PatientDataPage
  };

  return (
    <div className="schedule-table">
      {/* {console.log("currentData", currentData)} */}
      <table style={{ width: "100%" }}>
        <thead>
          <tr key="items">
            {/* <th>預約日期</th> */}
            <th>診所</th>
            <th>時段</th>
            <th>預約時間</th>
            <th>姓名</th>
            <th>證件號碼</th>
            <th>生日</th>
            <th>電話</th>
            <th>年齡</th>
            <th>性別</th>
            <th>診別</th>

            {/* <th>取消</th> */}
          </tr>
        </thead>
        <tbody>
          {currentData.map((oneData) => (
            <tr
              key={encodeURIComponent(btoa(oneData.createTime + oneData.ID))}
              style={{
                backgroundColor:
                  document.cookie
                    .split(";")
                    .find((row) => row.trim().startsWith("tempSave=")) &&
                  Object.keys(
                    JSON.parse(
                      document.cookie
                        .split(";")
                        .find((row) => row.trim().startsWith("tempSave="))
                        .split("=")[1]
                    )
                  ).includes(oneData.ID)
                    ? "#f5f5f5"
                    : "transparent",
              }}
            >
              {/* {console.log("oneData", oneData)} */}
              {/* {console.log("oneData.daflon", oneData.daflon)} */}
              {/* {console.log("oneData.growthHormone", oneData.growthHormone)} */}
              <td>{oneData.clinic}</td>
              <td>{oneData.hour}</td>
              <td>
                <strong>{oneData.time}</strong>
              </td>

              <td>
                <Button
                  onClick={() =>
                    user.account === "admin" ? showPatientData(oneData) : null
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                    background:
                      oneData.daflon &&
                      oneData.growthHormone &&
                      oneData.omnitrop
                        ? "linear-gradient(to right, #ffe8b6 33%, #FFB6C1 33%, #FFB6C1 66%, #b6deff 66%)"
                        : oneData.daflon && oneData.growthHormone
                        ? "linear-gradient(to right, #ffe8b6 50%, #FFB6C1 50%)"
                        : oneData.daflon && oneData.omnitrop
                        ? "linear-gradient(to right, #ffe8b6 50%, #b6deff 50%)"
                        : oneData.growthHormone && oneData.omnitrop
                        ? "linear-gradient(to right, #FFB6C1 50%, #b6deff 50%)"
                        : oneData.daflon
                        ? "#ffe8b6"
                        : oneData.growthHormone
                        ? "#FFB6C1"
                        : oneData.omnitrop
                        ? "#b6deff"
                        : "#A8D8B9",
                    margin: "0px",
                    padding: "0px",
                    minWidth: "8vw",
                    cursor: user.account === "admin" ? "pointer" : "default",
                  }}
                >
                  {oneData.name}
                </Button>
              </td>
              <td>{oneData.ID}</td>
              <td>{oneData.birthday}</td>
              <td>{oneData.phone}</td>
              <td>{calculateAge(oneData.birthday)}</td>
              <td>{oneData.gender}</td>
              <td>{oneData.first ? "初診" : "複診"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {user.account === "admin" ||
      user.account === "hansheng" ||
      user.account === "yoyo" ? (
        <>
          <Button
            style={{
              backgroundColor: "#ffe8b6",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97天有使用GnRHa
          </Button>
          <Button
            style={{
              backgroundColor: "#FFB6C1",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97天有使用Saizen
          </Button>
          <Button
            style={{
              backgroundColor: "#b6deff",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97天有使用omnitrop
          </Button>
          {/* <Button
            style={{
              backgroundColor: "#b6deff",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97天有使用Omnitrop
          </Button> */}
          <Button
            style={{
              backgroundColor: "#A8D8B9",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97沒有使用任何藥物
          </Button>
        </>
      ) : (
        <>
          <Button
            style={{
              backgroundColor: "#FFB6C1",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            過去21-97天有使用藥物
          </Button>
          <Button
            style={{
              backgroundColor: "#A8D8B9",
              margin: "10px",
              padding: "10px",
              cursor: "default",
              border: "1px solid black",
            }}
            disabled={true}
          >
            沒有使用任何藥物
          </Button>
        </>
      )}
    </div>
  );
};
export const ConfirmMsg = ({ confirmMessage, onConfirm, onCancel }) => {
  return (
    <div
      className="modal"
      style={{ display: confirmMessage ? "block" : "none" }}
    >
      <div className="modal-content">
        <p dangerouslySetInnerHTML={{ __html: confirmMessage }}></p>
        <button onClick={onConfirm}>確認</button>
        <button onClick={onCancel}>取消</button>
      </div>
    </div>
  );
};
const Managerment = ({ user, setUser, clinicName, setClinicName }) => {
  // const callCountRef = useRef(0);

  // let clinic = clinicName === "hansheng" ? "菡生" : "宥宥";
  const navigate = useNavigate();
  const [data, setData] = useState({}); //! all data, key is date
  const [orginalData, setOrginalData] = useState([]); //! all data in array, each element is a record
  const [dataArray, setDataArray] = useState([]); //! all data, each element is one day's data
  const [selectedData, setSelectedData] = useState(false); //! selected data in array, first element is date, second element is data
  // const [user, setUser] = useState(null); //! for login the page
  const [patientData, setPatientData] = useState(null); //! for turn to patient page

  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmResult, setConfirmResult] = useState(null);

  const cleanData = (cdata) => {
    let newData = {};
    Object.keys(cdata).forEach((key) => {
      const hours = cdata[key].hours;

      Object.keys(hours).forEach((hour) => {
        if (hours[hour].show) {
          if (!newData[key]) {
            newData[key] = [];
          }
          Object.keys(hours[hour]).forEach((time) => {
            // if time starts with number
            if (time.match(/^\d/) || time === "onsite") {
              if (
                hours[hour][time].people.first.length > 0 ||
                hours[hour][time].people.follow.length > 0
              ) {
                // push hours[hour][time].people.first and hours[hour][time].people.follow to newData[key]
                newData[key].push(...hours[hour][time].people.first);
                newData[key].push(...hours[hour][time].people.follow);
              }
            }
          });
        }
      });
    });
    let newDataArray = Object.entries(newData);
    return newDataArray;
  };
  const showConfirmDialog = (message) => {
    return new Promise((resolve) => {
      setConfirmMessage(message);
      // setConfirm(true);

      const handleConfirm = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(true);
      };

      const handleCancel = () => {
        // setConfirm(false);
        setConfirmMessage("");
        resolve(false);
      };
      setConfirmResult({ handleConfirm, handleCancel });
    });
  };
  // if (user) {
  //   let { originalData_temp, data_temp } = await fetchData(userData.clinic);
  //   let newDataArray = cleanData(data_temp);
  //   setDataArray(newDataArray);
  //   setSelectedData(newDataArray[0]);
  //   setOrginalData(originalData_temp);
  //   setData(data_temp);
  // }
  useEffect(() => {
    // 這個useEffect是用來第一次載入頁面時，取得資料
    //用localStorage取得userData, 如果userData可以找到並且createTime比現在的時間大，setUser(userData)
    //userData.createTim的格式如2024-09-05-15-01-22
    // const userData = JSON.parse(localStorage.getItem("userData"));

    const fetchDataAndSetState = async () => {
      let userData = JSON.parse(localStorage.getItem("userData"));

      if (userData) {
        const currentTime = await config.getTaipeiTimeString();
        if (compareDate(userData.createTime, currentTime)) {
          userData.createTime = currentTime;
          setUser(userData);
          setClinicName(userData.clinic); // 確保 clinicName 被設置
          let { originalData_temp, data_temp } = await fetchData(
            userData.clinic
          );
          let newDataArray = cleanData(data_temp);
          setDataArray(newDataArray);
          newDataArray[0] = await updateCurrentData(newDataArray[0]);
          setSelectedData(newDataArray[0]);
          setOrginalData(originalData_temp);
          setData(data_temp);
        } else {
          setUser(null);
          localStorage.removeItem("userData");
          navigate("/");
        }
      } else {
        navigate("/");
      }
    };
    fetchDataAndSetState();
    // fetchData_from_patient("aaa");
  }, []);
  const getDayOfWeek = (dateString) => {
    const daysOfWeek = ["日", "一", "二", "三", "四", "五", "六"];
    const date = new Date(dateString);
    const dayIndex = date.getDay();
    return daysOfWeek[dayIndex];
  };

  const handleChange = async (event) => {
    let selectedDate = Number(event.target.value);
    let selectedData_temp = dataArray[selectedDate];
    // selectedData_temp.selectedDate = selectedDate;
    selectedData_temp = await updateCurrentData(selectedData_temp);
    console.log("selectedData_temp", selectedData_temp);
    setSelectedData(selectedData_temp);
  };

  return (
    <div>
      {user && (
        <>
          {confirmMessage && confirmResult && (
            // <div>{alertMessage}</div>
            <ConfirmMsg
              confirmMessage={confirmMessage}
              onConfirm={confirmResult.handleConfirm}
              onCancel={confirmResult.handleCancel}
            />
          )}
          {/* <Navbars signOut={signOut} user={user.account} /> */}
          <div
            style={{
              width: "90vw",
              margin: "0 auto",
              // display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {debug && <h2>debug mode</h2>}
            {/* if patient is not null show patentdata or show other data */}
            {patientData ? (
              <div>
                <PatientDataPage
                  patientData={patientData}
                  setPatientData={setPatientData}
                  setData={setData}
                  clinicName={clinicName}
                />
              </div>
            ) : (
              <div>
                {!data ? (
                  <View style={{ width: "100%", overflowX: "auto" }}>
                    <h4>網頁目前維護中...</h4>
                  </View>
                ) : Object.keys(data).length === 0 ? (
                  <View style={{ width: "100%", overflowX: "auto" }}>
                    <h4>讀取中...</h4>
                  </View>
                ) : (
                  <View style={{ width: "100%", overflowX: "auto" }}>
                    {/* <Text as="h2">當前頁面路徑: {location.pathname}</Text> */}
                    {/* <Text>{JSON.stringify(selectedData)}</Text> */}
                    <br />
                    <Flex
                      // direction="row"
                      justifyContent="center"
                    >
                      <h4>兒童成長發育專科門診預約系統</h4>
                    </Flex>
                    {
                      <Flex direction="row" justifyContent="center">
                        <SelectField
                          // value={dataArray[2][0]}
                          onChange={handleChange}
                          margin="0 0px"
                        >
                          {dataArray.map((oneDayData, i) => (
                            <option key={i} value={i}>
                              {oneDayData[0]} ({getDayOfWeek(oneDayData[0])})
                            </option>
                          ))}
                        </SelectField>
                      </Flex>
                    }

                    {/* <RenderTable selectedData={selectedData} /> */}
                    <View>
                      <RenderTable
                        selectedData={selectedData}
                        setPatientData={setPatientData}
                        user={user}
                      />
                    </View>
                  </View>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Managerment;
